import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ORIENTATION_ANGLE } from '../../../commons/constants';

import useWindowSize from '../../../hooks/useWindowSize';
import { storeName } from '../../../redux/models/layout.model';
import { storeName as layoutModelStoreName } from '../../../redux/models/layout.model';

const ResizeFragment: FC = () => {
  const isMobileDevice = useSelector((state) => state[layoutModelStoreName].isMobileDevice);
  const { size } = useWindowSize({ disabledResize: !!isMobileDevice });

  const layoutModelDispatch = useDispatch()[storeName];

  useEffect(() => {
    // check Touch device (ipad/phone)
    if (navigator.maxTouchPoints && size) {
      layoutModelDispatch.setOrientationAngle(
        size.width > size.height ? ORIENTATION_ANGLE.LANDSCAPE : ORIENTATION_ANGLE.PORTRAIT
      );
    }
  }, [size]);

  return <div className="bds-resize-fragment" style={{ width: size.width, height: size.height }} />;
};

export default React.memo(ResizeFragment);
